<template lang='pug'>
#modal-vincular-car-obrigatorio-territorio
    el-dialog(
        :visible.sync='show',
        :show-close="false"
        :title="$t('mensagens.territorio.vinculacaoCarTerritorio')",
        :close-on-click-modal='false'
    )
        p {{ $t('mensagens.territorio.vinculacaoCarTerritorioObrigatoria') }}

        el-form(label-position='top')
            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.territorio.numeroDoCar') }}
                    span(style='color: red') *

                el-input(
                    v-model='numeroCar',
                    :placeholder="$t('mensagens.territorio.insiraNumeroCar')"
                    maxlength='43'
                )

        .modal-vincular-car-obrigatorio-territorio__footer(slot='footer')
            BaseButton(
                type='default',
                @click='removeTerritorio'
            )
                | {{ $t('mensagens.comuns.voltar') }}
            BaseButton(type='primary', @click='findCar')
                | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import territorioService from '@/services/TerritorioService';
import CarUtils from '@/utils/CarUtils';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalVincularCarObrigatorioTerritorio',
    components: {
        BaseButton
    },
    emits: ['close', 'delete-desenho-geometria'],
    props: {
        show: {
            type: Boolean,
            required: true
        },
        payload: {
            required: true
        }
    },
    data() {
        return {
            numeroCar: null
        };
    },
    watch: {
        numeroCar: function (value) {
            value = value.replace(/[^\w\s]/gi, '');

            this.numeroCar = CarUtils.addMascaraCar(value).toUpperCase();
        }
    },
    computed: {
        ...mapGetters(['territoryTableData'])
    },
    methods: {
        ...mapActions(['removeTerritoryTableData']),

        async findCar() {
            if (this.numeroCar && this.numeroCar.length === 43) {
                await territorioService
                    .findByCar(this.numeroCar)
                    .then(response => {
                        if (response.status === 200) {
                            this.payload.type = 'CAR';
                            this.payload.codigo = response.data.codigoCAR;
                            this.$notify.success({
                                message: this.$t('mensagens.territorio.carAdicionadoComSucesso')
                            });
                        } else {
                            this.$notify.error({
                                message: this.$t('mensagens.territorio.carNaoEncontradoBaseLyra')
                            });
                        }

                        this.$emit('close');
                    })
                    .catch(() =>
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.carNaoEncontradoBaseLyra')
                        })
                    );
            } else {
                this.$notify.warning({
                    message: this.$t('mensagens.territorio.informeNumeroCarValido')
                });
            }
        },
        removeTerritorio() {
            const index = this.territoryTableData.findIndex(item => item.identificadorGeometria === this.payload.identificadorGeometria);
            if (this.payload.type === 'UPLOAD') {
                this.$emit('delete-upload-file', this.payload.fileName);
            } else {
                this.$root.$emit('remove-map-layer', this.payload.identificadorGeometria);
                this.removeTerritoryTableData(index);
            }
            this.$emit('click-delete-area');
            this.$emit('close');
        }
    }
};
</script>

<style lang='scss'>
#modal-vincular-car-obrigatorio-territorio {

    .modal-vincular-car-obrigatorio-territorio__footer {
        display: contents;
    }

    .el-dialog__header {
        background-color: whitesmoke;
    }

    .el-dialog__title {
        font-weight: 600;
        color: #00413c;
    }

    .el-dialog__footer {
        display: flex;
        justify-content: space-between;
    }

    .el-dialog__body {
        word-break: break-word;
    }
}
</style>
